import { render, staticRenderFns } from "./UserUsageData.vue?vue&type=template&id=50416cf0"
import script from "./UserUsageData.vue?vue&type=script&lang=js"
export * from "./UserUsageData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports